"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSanitizedFieldOrder = exports.getSanitizedFieldList = exports.getDefaultStandardFieldMetadata = exports.getDefaultCustomFieldMetadata = void 0;
var _sdk = require("../../../sdk");
var _issueStandardFields = require("./issueStandardFields");
const getDefaultStandardFieldMetadata = fieldId => {
  let defaultVisibility = true;
  if (fieldId === _sdk.IssueStandardFieldIds.GpsCoordinates) {
    defaultVisibility = false;
  }
  return {
    type: "standard",
    id: fieldId,
    visible: defaultVisibility
  };
};
exports.getDefaultStandardFieldMetadata = getDefaultStandardFieldMetadata;
const getDefaultCustomFieldMetadata = customFieldId => {
  return {
    type: "custom",
    id: customFieldId,
    visible: true
  };
};
exports.getDefaultCustomFieldMetadata = getDefaultCustomFieldMetadata;
const getSanitizedFieldList = _ref => {
  let {
    fieldList,
    customFieldIdsForType
  } = _ref;
  const customFieldIdsForTypeAsSet = new Set(customFieldIdsForType);
  return fieldList.filter(field => {
    if (!field) {
      return false;
    }
    // filter out any weird data that has an invalid type
    if (!["standard", "custom"].includes(field.type)) {
      return false;
    }
    // filter out any weird standard field data
    if (field.type === "standard" && !_issueStandardFields.DEFAULT_FIELD_ORDER.includes(field.id)) {
      return false;
    }
    // filter out any custom fields that do not currently belong to the type
    if (field.type === "custom" && !customFieldIdsForTypeAsSet.has(field.id)) {
      return false;
    }
    return true;
  });
};

/**
 * we need to add to the field list any custom fields,
 * and we need to make sure that the fixed fields are always at the top.
 */
exports.getSanitizedFieldList = getSanitizedFieldList;
const useGetSanitizedFieldOrder = _ref2 => {
  let {
    fieldList,
    customFieldIdsForType,
    shouldShowAttachments = false
  } = _ref2;
  let fieldListCopy = getSanitizedFieldList({
    fieldList,
    customFieldIdsForType
  });

  // Add all of the standard fields to the beginning, in order,
  // if they are not already included in the metadata.
  const standardFieldIdsAlreadyInMetadata = new Set(fieldListCopy.filter(field => {
    return field.type === "standard";
  }).map(field => field.id));
  // for the default order, we need a reversed version so we can iterate through it and push items into the front:
  // this gives us the correct order
  const reversedStandardFieldDefaultOrder = [..._issueStandardFields.DEFAULT_FIELD_ORDER];
  reversedStandardFieldDefaultOrder.reverse();
  reversedStandardFieldDefaultOrder.forEach(standardFieldId => {
    if (!standardFieldIdsAlreadyInMetadata.has(standardFieldId)) {
      fieldListCopy.unshift(getDefaultStandardFieldMetadata(standardFieldId));
    }
  });

  // we add any custom fields not included in the existing fields metadata
  const customFieldIdsAlreadyInMetadata = new Set(fieldListCopy.filter(field => {
    return field.type === "custom";
  }).map(field => field.id));

  // if some of the default bottom fields are at the bottom, the custom fields not specified in the metadata
  // should be above them. Otherwise we add the custom fields in their specified place.
  const lastDefaultFields = [..._issueStandardFields.DEFAULT_BOTTOM_FIELDS].reverse();
  if (!shouldShowAttachments) {
    const attachmentIndex = lastDefaultFields.indexOf(_sdk.IssueStandardFieldIds.Attachments);
    lastDefaultFields.splice(attachmentIndex, 1);
  }

  // count how many of the last default fields are in their default place
  const lastDefaultFieldsInDefaultPlaceCount = lastDefaultFields.reduce((acc, fieldId, index) => {
    return fieldListCopy[fieldListCopy.length - (index + 1)].id === fieldId ? acc + 1 : acc;
  }, 0);
  customFieldIdsForType.forEach(customFieldId => {
    if (!customFieldIdsAlreadyInMetadata.has(customFieldId)) {
      fieldListCopy.splice(lastDefaultFieldsInDefaultPlaceCount ?
      //use negative index to insert the custom field above the first bottom default field
      -1 * lastDefaultFieldsInDefaultPlaceCount : fieldListCopy.length, 0, getDefaultCustomFieldMetadata(customFieldId));
    }
  });

  // set the required field to false by default if it is not specified
  fieldListCopy = fieldListCopy.map(field => ({
    required: false,
    ...field
  }));

  // if attachments are not shown, remove the attachments field
  if (!shouldShowAttachments) {
    fieldListCopy = fieldListCopy.filter(field => {
      return field.id !== _sdk.IssueStandardFieldIds.Attachments;
    });
  }
  return fieldListCopy;
};
exports.useGetSanitizedFieldOrder = useGetSanitizedFieldOrder;
//# sourceMappingURL=issueFieldOrdering.js.map